var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.234375,
    y: 0.696045,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.734375,
    y: 1.19604,
    width: 23,
    height: 23,
    rx: 5.5,
    stroke: "#355389",
    strokeOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1169 11.0082C17.1169 11.0082 16.7549 15.4982 16.5449 17.3895C16.4449 18.2928 15.8869 18.8222 14.9729 18.8388C13.2336 18.8702 11.4923 18.8722 9.75358 18.8355C8.87425 18.8175 8.32558 18.2815 8.22758 17.3942C8.01625 15.4862 7.65625 11.0082 7.65625 11.0082",
    stroke: "#2860B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0397 8.85586H6.73438",
    stroke: "#2860B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8608 8.85585C15.3374 8.85585 14.8868 8.48585 14.7841 7.97318L14.6221 7.16251C14.5221 6.78851 14.1834 6.52985 13.7974 6.52985H10.9754C10.5894 6.52985 10.2508 6.78851 10.1508 7.16251L9.98878 7.97318C9.88611 8.48585 9.43544 8.85585 8.91211 8.85585",
    stroke: "#2860B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDelete);
export default __webpack_public_path__ + "static/media/user_delete.a4d8551828d0267d9e24aef03ca43457.svg";
export { ForwardRef as ReactComponent };